import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useDocumentTitleHelperBreadcrumbItems from "./useDocumentTitleHelperBreadcrumbItems";
import { selectHeadTitle, selectCounterStatus } from "../../features/counter/counterSlice";

export const DocumentTitleHelper = () => {
  const { pathname, search } = useLocation();
  const { breadcrumbItems } = useDocumentTitleHelperBreadcrumbItems({});
  const counterStatus = useSelector(selectCounterStatus);
  const headTitle = useSelector(selectHeadTitle);
  const prevHeadTitleRef = useRef(null);

  useEffect(() => {
    const isCounterStillLoading = counterStatus !== "idle";
    const isOnViewTopicPath = pathname.includes("viewTopic") || pathname.includes("topicTeaser");
    const isTopicStillLoading =
      isOnViewTopicPath && (!headTitle || headTitle === prevHeadTitleRef.current);
    // extend wait time if viewTopic URL. This takes longest to load
    const timeoutTime = isCounterStillLoading || isTopicStillLoading ? 1600 : 400;

    const debouncedTitleUpdate = setTimeout(() => {
      let title = `Therapeutic Guidelines`;
      let contentGroup = undefined; // GTM will ignore if undefined but still send "null"

      if (breadcrumbItems?.length > 0) {
        const lastItem = breadcrumbItems?.at(-1);
        if (lastItem?.label) {
          title = `${lastItem.label} - Therapeutic Guidelines`;
        }

        const hasGuidelineBreadcrumb = breadcrumbItems[0]?.path === "/guidelines";
        if (hasGuidelineBreadcrumb) {
          const guidelineLabel = breadcrumbItems[1]?.label;
          const normalisedLabel = guidelineLabel
            ?.toLowerCase()
            ?.trim()
            ?.replace(/[^\w\s-]/g, "")
            ?.replace(/\s+/g, "-");
          if (normalisedLabel) {
            contentGroup = `guidelines/${normalisedLabel}`;
          }
        }
      }
      if (document.title !== title) {
        document.title = title;

        if (isOnViewTopicPath) {
          prevHeadTitleRef.current = headTitle;
        }

        // send custom event for GTM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "page_title_updated",
          page_location: window.location.href,
          page_title: title,
          content_group: contentGroup,
        });
      }
    }, timeoutTime);
    return () => {
      clearTimeout(debouncedTitleUpdate);
    };
  }, [breadcrumbItems, counterStatus, pathname, search, headTitle]);

  return null;
};
